import { GetPostsError } from "../../domain/errors/errors.js";
import { extractApiError } from "@vana/core";
//#region src/persistance/repositories/post-repo.ts
var PostRepo = class {
	apiClient;
	constructor(apiClient) {
		this.apiClient = apiClient;
	}
	async getPosts() {
		try {
			return (await this.apiClient.get("posts")).data ?? [];
		} catch (error) {
			const { message, apiError } = extractApiError(error);
			throw new GetPostsError(message, apiError);
		}
	}
};
//#endregion
export { PostRepo };

//# sourceMappingURL=post-repo.js.map